import React from "react";
import AnimatedLogo from "./AnimatedLogo";

type BackgroundLogoProps = {
  onAnimationComplete?: () => void;
};

const BackgroundLogo: React.FC<BackgroundLogoProps> = ({ onAnimationComplete }) => {
  return (
    <div
      className="
        fixed inset-0 z-0 
        flex items-center justify-center 
        pointer-events-none
      "
    >
      <div className="h-[30vh] w-[30vh] max-h-[600px] max-w-[600px]">
        <AnimatedLogo onComplete={onAnimationComplete} />
      </div>
    </div>
  );
};

export default BackgroundLogo;
